<template>
  <div :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="个人信息"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="mybox" :style="{ height: pageHeight+ 'px' }" style="margin-top:46px;">
      <div class="myitem">
        <van-cell center title="头像"   value="" @click="changeFacePage">
          <!-- 使用 right-icon 插槽来自定义单元格最右侧的额外内容 -->
          <template #right-icon>
            <van-image width="32px" height="32px" round fit="cover" :src="imgSrc" >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
            <i class="van-icon van-icon-arrow van-cell__right-icon"></i>

          </template>
        </van-cell>
        <van-cell title="昵称" is-link  :value="cpName" @click="openOverlay"/>
        <!-- <van-cell title="手机号" is-link  value="15607164791" to="changeTelPage"/> -->
        <van-overlay :show="showO" @click="showO = false">
          <div class="wrapper" @click.stop>
            <div class="block">
             <van-nav-bar
              title="编辑昵称"
              left-text="取消"
              @click-left="closeOverlay"
            />
            <div class="mybox">
              <van-form validate-first @failed="onFailed">
                <!-- 通过 pattern 进行正则校验 -->
                <van-field
                  v-model="cpName"
                  center
                  clearable
                  label="昵称"
                  :placeholder="cpName"
                />
                <div style="margin: 16px 0;">
                  <van-button  block type="info" native-type="submit" @click="save">保存</van-button>
                </div>
              </van-form>
            </div>
            </div>
          </div>
        </van-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Col, Row, Image as VanImage, NavBar, Cell, CellGroup, Button, Overlay, Form, Field, Loading } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Tabbar, TabbarItem, Col, Row, VanImage, NavBar, Cell, CellGroup, Button, Overlay, Form, Field, Loading)

export default {
  name: 'changeUserPage',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Form.name]: Form,
    [Field.name]: Field,
    [Loading.name]: Loading
  },
  created () {
    // console.log('created')
    this.cpName = this.$route.query.cpname
    this.phoneNum = this.$route.query.phoneNum
    this.getimgSrc()
    this.imgSrc = `${this.setUserImages()}&v=${Math.random() * 10}`
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)// 返回上一页面
    },
    openOverlay () {
      // 打开修改昵称遮罩层
      this.showO = true
    },
    closeOverlay () {
      // 关闭修改昵称遮罩层
      this.showO = false
    },
    onFailed (errorInfo) {
      // console.log('failed', errorInfo)
    },
    save () {
      this.util.post('/updatePersonalName', {
        cpName: this.cpName
      }).then(({ data }) => {
        if (data.code === 200) {
          // 登录按钮执行登录的时候，存localStorage
          this.util.toast(data.msg)
          setTimeout(() => {
            this.closeOverlay()
          }, 1000)
        } else {
          // 验证失败
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    changeFacePage () {
      this.$router.push({
        path: '/changeFacePage', query: { cpname: this.cpname, phoneNum: this.phoneNum }
      })
    },
    setUserImages () {
      return window.config.baseUrl+'/showTXImg?phoneNum=' + this.phoneNum// 用户头像接口
    },
    getimgSrc () {
      this.imgSrc = window.config.baseUrl+'/showTXImg?phoneNum=' + this.phoneNum// 用户头像接口
      // console.log(this.imgSrc)
    }

  },
  data () {
    return {
      imgSrc: '',
      cpName: '',
      phoneNum: '',
      // imgSrc: require('../assets/tx@3x.png'),
      showO: false, // 修改昵称遮罩层默认不显示
      pageHeight: window.innerHeight - 46
    }
  }
}
</script>

<style scoped lang="less">
  /deep/.van-nav-bar__text {
      color: #353535;
  }
  /deep/.van-nav-bar__content {
    height: 46px;
  }
  /deep/.van-nav-bar__title {
    font-size: 17px;
    font-weight: bold;
  }
  /deep/.van-nav-bar .van-icon {
    font-size: 17px;
    color: #A6A6A6;
  }
 .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 100vw;
    height: 100vh;
    background-color: #fff;
  }

</style>
